const pnpReducer = (state = [], action) => {
  switch (action.type) {
    case "TITLE":
      return {
        title: action.title
      };
    default:
      return state;
  }
};
export default pnpReducer;
